
export class SaveChangeFixationModel {
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  // 共通項目タブ
  public commonItem: Array<any> = new Array<any>();

  // 生協情報タブ群
  public coopItem: Array<any> = new Array<any>();

  // アイテム情報タブ群
  public itemCodeItem: Array<any> = new Array<any>();

  // 次回案内情報タブ群
  public nextGuideItem: Array<any> = new Array<any>();

  // 抽選情報タブ群
  public lotteryPromotionItem: Array<any> = new Array<any>();

  /** クーポン情報タブ群 クーポンプロモーション情報 */
  public couponPromotionItem: Array<any> = new Array<any>();

  /** クーポン情報タブ群 会員生協別クーポン値引額管理情報 */
  public couponApplicablePriceItem: Array<any> = new Array<any>();

  /** ポイント情報タブ群 企画商品ポイント交換基本情報 */
  public pointExchangeBaseItem: Array<any> = new Array<any>();

  /** ポイント情報タブ群 企画商品ポイント交換利用生協情報 */
  public pointExchangeCoopItem: Array<any> = new Array<any>();
  
  /** 1物N価情報タブ群 */
  public planGoodsNvalPromotionItem: Array<any> = new Array<any>();

  /** EC情報タブ群 */ 
  public planGoodsECItem: Array<any> = new Array<any>();

  /** EC情報タブ群 会員生協別EC在庫限定情報 */
  public planGoodsCoopECStockItem: Array<any> = new Array<any>();

  /** 予約情報タブ群 企画予約商品情報 */
  public planGoodsPreOrderItem: Array<any> = new Array<any>();

  /** 予約情報タブ群 企画予約商品利用生協情報 */
  public planGoodsPreOrderCoopItem: Array<any> = new Array<any>();
}